import React from 'react';
import '../styles/BlogPreview.css';

function BlogPreview() {
  return (
    <section className="blog-preview">
      <div className="container">
        <h2 className="section-title">Latest Blog Posts</h2>
        <div className="blog-cards">
          <div className="blog-card">
            <h3>How to Choose the Right Hosting</h3>
            <p>Learn key tips to select the best hosting for your business website.</p>
            <a href="#">Read More →</a>
          </div>
          <div className="blog-card">
            <h3>Benefits of Having a Mobile App</h3>
            <p>Explore how a mobile app can boost customer engagement and sales.</p>
            <a href="#">Read More →</a>
          </div>
          <div className="blog-card">
            <h3>E-commerce Trends in 2025</h3>
            <p>Discover the top trends that will dominate the e-commerce landscape.</p>
            <a href="#">Read More →</a>
          </div>
        </div>
      </div>
    </section>
  );
}

export default BlogPreview;